import { useCallback } from 'react';
import PortalAppService from '../../../application/platform/portal-app-service';
import BaseAppService from '../../../application/platform/base-app-service';
import { useFAQDispatch } from './faq-context';
import { IListQuestionAnwserRequest } from '../../../model/base/request/list-question-anwser-request';

export function useFAQController() {
  const dispatch = useFAQDispatch();

  const loadCategories = useCallback(async () => {
    try {
      const categories = await BaseAppService.getListCategporyQuestionAnswer();
      dispatch({ type: 'SET_CATEGORIES', payload: categories });
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  }, [dispatch]);

  const loadFAQs = useCallback(async (params: IListQuestionAnwserRequest) => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      dispatch({ type: 'SET_ERROR', payload: null });

      const response = await PortalAppService.listQuestionAwnser(params);
      dispatch({ type: 'SET_FAQS', payload: response.items || [] });
    } catch (error) {
      console.error('Error loading FAQs:', error);
      dispatch({ type: 'SET_ERROR', payload: 'Erro ao carregar as perguntas frequentes.' });
    }
  }, [dispatch]);

  return {
    loadCategories,
    loadFAQs,
  };
}
